export enum StoredState {
  SidebarOpen = 'sidebar-open',
  OnboardingWizardStep = 'onboarding-wizard-step',
  OnboardingWizardVisible = 'onboarding-wizard-visible',
  OnboardingWizardCollapsed = 'onboarding-wizard-collapsed',
  MobileNavSettingsExpanded = 'mobile-nav-settings-expanded',
}
